import { render, staticRenderFns } from "./AddEditTaxProfiles.vue?vue&type=template&id=7cb4692b&scoped=true&"
import script from "./AddEditTaxProfiles.vue?vue&type=script&lang=js&"
export * from "./AddEditTaxProfiles.vue?vue&type=script&lang=js&"
import style0 from "./AddEditTaxProfiles.vue?vue&type=style&index=0&id=7cb4692b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb4692b",
  null
  
)

export default component.exports